module.exports = __webpack_public_path__ + "static/media/20-3.e36997c2.mp3";